exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiselect.form-control.multiselect-input {\n    box-sizing: border-box;\n    padding: 0.75rem 0rem;\n}\n.multiselect-input .multiselect__tags {\n    min-height: 20px !important;\n    padding-top: unset !important;\n}\n", ""]);

// exports
